import { districtColumns, provinceColumns } from '../../cols-definition';
import { FormField } from '@/components/custom/erp';
import { useAuth } from '@/contexts/auth-context';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface FormProps {
  mode: FormMode;
}
function WardForm({ mode }: FormProps) {
  const { entity } = useAuth();

  return (
    <div className='p-4 md:p-6'>
      <div className='flex flex-col gap-y-4 md:gap-y-6'>
        <div className='space-y-4 md:space-y-6'>
          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã Xã/phường</Label>
            <FormField type='text' name='ma_xp' disabled={mode === 'view'} />
          </div>

          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên Xã/phường</Label>
            <FormField type='text' name='ten_xp' disabled={mode === 'view'} />
          </div>

          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên khác</Label>
            <FormField type='text' name='ten_xp2' disabled={mode === 'view'} />
          </div>

          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label htmlFor='ma_tinh' className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>
              Mã tỉnh/thành
            </Label>
            <FormField
              id='ma_tinh'
              type='text'
              name='ma_tinh'
              withSearch
              searchEndpoint='/provinces'
              searchColumns={provinceColumns}
              disabled={mode === 'view'}
            />
          </div>

          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label htmlFor='ma_quan' className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>
              Mã quận/huyện
            </Label>
            <FormField
              id='ma_quan'
              type='text'
              name='ma_quan'
              withSearch
              searchEndpoint='/districts'
              searchColumns={districtColumns}
              disabled={mode === 'view'}
            />
          </div>

          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label htmlFor='status' className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>
              Trạng thái
            </Label>
            <FormField
              id='status'
              type='select'
              name='status'
              defaultValue={1}
              options={[
                { label: '1. Còn sử dụng', value: 1 },
                { label: '2. Không sử dụng', value: 2 }
              ]}
              disabled={mode === 'view'}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default WardForm;
